import { getCommonParamsOptions } from '@/utils/common.js'

export const searchFormConfig = {
  formItems: [
    {
      field: 'name',
      type: 'input',
      label: 'param.param-name'
    },
    {
      field: 'paramType',
      type: 'select',
      label: 'param.param-value-type',
      isResolveGlobalParams: true,
      options: [],
      handler: () => getCommonParamsOptions('value_type'),
      otherOptions: {}
    },
    {
      field: 'status',
      type: 'select',
      label: 'general.status',
      isResolveGlobalParams: true,
      options: [],
      handler: () => getCommonParamsOptions('status'),
      otherOptions: {}
    },
    {
      field: 'createTime',
      type: 'datepicker',
      label: 'general.creation-date',
      otherOptions: {
        type: 'daterange'
      },
      dateFieldName: ['startDateTime', 'endDateTime']
    }
  ]
}
